import {
  ANIMAL_CHILD_TAGS,
  BIRTHDAY_FLOWER_CHILD_TAGS,
  FLOWER_CHILD_TAGS,
  POPULAR_TAGS,
  POPULAR_TAGS_ONE_K,
  SHOP_FACET_TATTOO_IDEAS,
  ZODIAC_CHILD_TAGS,
} from "@blackink/core/tagLists";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  NativeSelect,
  OutlinedInput,
  Typography,
  useMediaQuery,
  useTheme,
  Theme,
} from "@mui/material";
import React, { useCallback, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const ShopFilter = (props) => {
  const { title, items, onChange, showFullList = false, selected = null } = props;
  const [showAll, setShowAll] = useState(showFullList);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const theme = useTheme();
  const matchDownMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));
  const location = useLocation();

  const handleSelectChange = useCallback(
    (event) => {
      onChange(event.target.value);
    },
    [onChange],
  );

  const handleSelectItem = useCallback(
    (itemId, checked) => {
      onChange(checked ? itemId : null);
    },
    [onChange],
  );

  const popularTagsCombined = useMemo(() => {
    if (location.pathname.includes("/shop/temporary-tattoos")) {
      return [...new Set([...SHOP_FACET_TATTOO_IDEAS])];
    } else if (location.pathname.includes("tattoo-ideas")) {
      return [
        ...new Set([
          ...POPULAR_TAGS,
          ...POPULAR_TAGS_ONE_K,
          ...ANIMAL_CHILD_TAGS,
          ...FLOWER_CHILD_TAGS,
          ...BIRTHDAY_FLOWER_CHILD_TAGS,
          ...ZODIAC_CHILD_TAGS,
        ]),
      ];
    }
    return POPULAR_TAGS;
  }, [location.pathname]);

  const renderedItems = useMemo(() => {
    const itemsList = showAll || showFullList ? items : items.slice(0, 5);
    if (selected) {
      const selectedItemIndex = itemsList.findIndex((item) => item.id === selected);
      if (selectedItemIndex !== -1) {
        const [removed] = itemsList.splice(selectedItemIndex, 1);
        itemsList.unshift(removed);
      }
    }
    return itemsList;
  }, [items, showAll, showFullList, selected]);

  return (
    <Box flex={1}>
      {matchDownMd && (
        <Typography variant="subtitle3" color="primary" display="block">
          {title}
        </Typography>
      )}
      {matchDownMd ? (
        <NativeSelect
          variant="filled"
          input={
            <OutlinedInput
              notched={false}
              size="small"
              style={{ minWidth: "100%", maxWidth: 200 }}
            />
          }
          value={selected ?? ""}
          onChange={handleSelectChange}
          sx={{ width: "100%" }}
        >
          <option aria-label="All" value="" label="All" />
          {items.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </NativeSelect>
      ) : (
        <>
          <FormControl>
            {renderedItems.map((item) => (
              <span key={item.id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      sx={{ py: 0.8 }}
                      onChange={(event, checked) => handleSelectItem(item.id, checked)}
                      checked={selected === item.id}
                    />
                  }
                  label={
                    (location.pathname.includes("tattoo-ideas") ||
                      location.pathname.includes("/shop/temporary-tattoos")) &&
                    popularTagsCombined.indexOf(item.id) > -1 &&
                    !["style", "placement"].includes(title.toLowerCase()) ? (
                      <Link
                        target="_blank"
                        style={{
                          color: "inherit",
                          lineHeight: 1,
                          padding: 1,
                          display: "inline-block",
                        }}
                        to={
                          (location.pathname.includes("/shop/temporary-tattoos")
                            ? `/shop/temporary-tattoos/`
                            : `/tattoo-ideas/`) +
                          (popularTagsCombined.indexOf(item.id) > -1 ? item.id : null)
                        }
                      >
                        {item.name}
                      </Link>
                    ) : (
                      item.name
                    )
                  }
                  sx={{ mr: 0 }}
                />
              </span>
            ))}
          </FormControl>
          {Object.keys(items).length > 5 && !showFullList && (
            <Button
              onClick={() => setShowAll(!showAll)}
              color="inherit"
              size="small"
              sx={{ display: "block" }}
            >
              {showAll ? "Show Less" : "Show More"}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export default ShopFilter;
